import { gql } from '@apollo/client';

export const PersonSummaryFragment = gql(`
    fragment PersonSummaryFragment on Person {
        __typename
        sys {
            id
        }
        firstName
        lastName
        profileImage {
            ...ImageWrapperFragment
        }
    }
`);
